// store/index.ts
import { createStore } from 'vuex';
import user from './user';
import itemList from './itemList';

const store = createStore({
  modules: {
    user,
    itemList,
  }
});

export default store;